<template>
  <div>
    <!-- Modal Create -->
    <PerfilFormModal
      mode="create"
      :tiposColaborador="tiposColaborador"
      :descSingular="descSingular"
      :onSubmit="createItem"
      :close="closeCreate"
    />

    <!-- Modal Edit -->
    <PerfilFormModal
      mode="edit"
      :item="currentItem"
      :access="currentAccess"
      :sistemas="sistemas"
      :tiposColaborador="tiposColaborador"
      :descSingular="descSingular"
      :onSubmit="updateItem"
      :close="closeEdit"
      :addAcesso="addAcesso"
      :remAcesso="remAcesso"
      :addAcessoModuloAcoes="addAcessoModuloAcoes"
      :remAcessoModuloAcoes="remAcessoModuloAcoes"
    />
    <Loading :isActive="loading"></Loading>
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab :title="descPlural">
        <div class="row">
          <div class="col-6">
            <span class="filters__search">
              <input
                type="text"
                v-model="searchTerm"
                placeholder="Buscar por..."
                @input="filterItems"
              />
              <fa-icon icon="search" />
            </span>
          </div>
          <div class="col-6 text-right header-buttons">
            <CButton color="primary" @click="openCreate" size="sm">
              <fa-icon icon="plus" />
              Novo registro
            </CButton>
          </div>
        </div>
        <div class="table-responsive mt-3">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Id</th>
              <th>Descrição</th>
              <th>Ativo</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="displayItems.length === 0">
              <td colspan="4" class="text-center" style="padding: 2rem;">
                <span v-if="searchTerm">Nenhum resultado encontrado para "{{ searchTerm }}"</span>
                <span v-else>Nenhum registro encontrado</span>
              </td>
            </tr>
            <tr v-for="item in displayItems" :key="item.id">
              <td class="highlight">{{ item.id }}</td>
              <td>{{ item.descricao }}</td>
              <td>
                <span class="label success" v-if="item.ativo">Ativo</span>
                <span class="label error" v-else>Inativo</span>
              </td>
              <td class="actions">
                <CButton color="primary" size="sm" @click="openEdit(item)" class="mr-1">
                  <fa-icon icon="pencil-alt" />
                </CButton>
                <CButton color="danger" size="sm" @click="deleteConfirm(item.id)">
                  <fa-icon icon="trash-alt" />
                </CButton>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>
<script>
import clone from 'just-clone';
import { get, post, put, del } from '@/helpers/apiRequest';
import PerfilFormModal from './PerfilFormModal';

export default {
  name: 'perfis',
  components: {
    PerfilFormModal,
  },
  props: [
    'sistemas'
  ],
  data() {
    return {
      descPlural: '',
      descSingular: '',
      loading: false,
      items: [],
      filteredItems: [],
      searchTerm: '',
      tiposColaborador: [],
      modulos: [],
      currentItem: {},
      currentAccess: false,
    };
  },
  computed: {
    displayItems() {
      return this.filteredItems.length > 0 || this.searchTerm ? this.filteredItems : this.items;
    }
  },
  methods: {
    filterItems() {
      if (!this.searchTerm) {
        this.filteredItems = [];
        return;
      }
      const term = this.searchTerm.toLowerCase();
      this.filteredItems = this.items.filter(item => {
        return (
          item.id.toString().includes(term) ||
          (item.descricao && item.descricao.toLowerCase().includes(term))
        );
      });
    },
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem('app'));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === 'ADMIN_PERFIL'
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadPerfis() {
      this.loading = true;
      get('/admin/perfis')
        .then((json) => {
          this.items = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadTiposColaborador() {
      this.loading = true;
      get('/admin/perfis/tipos-colaborador')
        .then((json) => {
          this.tiposColaborador = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    openCreate() {
      this.$modal.show('perfilCreate');
    },
    closeCreate() {
      this.$modal.hide('perfilCreate');
    },
    createItem(item) {
      this.loading = true;
      post('/admin/perfis', item)
        .then((json) => {
          this.items.push(json);
          this.loading = false;
          this.closeCreate();
          this.openEdit(json);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openEdit(item, showLoading = true) {
      this.currentItem = clone(item);
      if (showLoading) {
        this.loading = true;
      }
      get(`/admin/perfis/${this.currentItem.id}`).then((json) => {
        this.currentAccess = json;
        if (showLoading) {
          this.loading = false;
          this.$modal.show('perfilEdit');
        }
      });
    },
    closeEdit() {
      this.$modal.hide('perfilEdit');
    },
    updateItem(item) {
      this.loading = true;
      const itemToUpdate = item || this.currentItem;
      const { id } = itemToUpdate;

      // Atualiza currentItem com os dados do formulário
      this.currentItem = { ...itemToUpdate };

      put(`/admin/perfis/${id}`, itemToUpdate)
        .then(() => {
          this.loading = false;
          this.loadPerfis();
          this.closeEdit();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteConfirm(id) {
      this.$swal({
        title: 'Confirma Remover ?',
        text: 'Essa ação não poderá ser desfeita',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/perfis/${id}`)
              .then((json) => {
                this.loading = false;
                this.loadPerfis();
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: 'Falha ao remover',
                  icon: 'error',
                });
              });
          }
        })
        .catch(() => {});
    },
    addAcesso(perfil, perfil_id, modulo_id) {
      let request =  post(`/admin/perfis/${perfil_id}/modulos/${modulo_id}`)

      request
        .then((json) => this.openEdit(perfil, false))
        .catch((error) => {});

      return request;
    },
    remAcesso(perfil, perfil_id, modulo_id) {
      let request =  del(`/admin/perfis/${perfil_id}/modulos/${modulo_id}`)

      request
        .then((json) => this.openEdit(perfil, false))
        .catch((error) => {});

      return request;
    },
    addAcessoModuloAcoes(perfil, perfil_id, modulo_id, modulo_acao_id) {
      let request =  post(`/admin/perfis/${perfil_id}/modulos/${modulo_id}/acao/${modulo_acao_id}`)

      request
        .then((json) => this.openEdit(perfil, false))
        .catch((error) => {});

      return request;
    },
    remAcessoModuloAcoes(perfil, perfil_id, modulo_id, modulo_acao_id) {
      let request =  del(`/admin/perfis/${perfil_id}/modulos/${modulo_id}/acao/${modulo_acao_id}`)

      request
        .then((json) => this.openEdit(perfil, false))
        .catch((error) => {});

      return request;
    },
  },
  beforeMount() {
    this.loadPerfis();
    this.loadTiposColaborador();
    this.loadDescricaoModulo();
  },
};
</script>

<style scoped>
.header-buttons button {
  margin-left: 5px;
}

.mr-1 {
  margin-right: 0.25rem;
}
</style>
